// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"41b35eb3","453":"6edae1c4","885":"8be3d829"}[chunkId] + ".chunk.js";
};